import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { NotificationService, PayoutService } from '../../../../_services';

@Component({
  selector: 'app-payout-report',
  templateUrl: './payout-report.component.html'
})
export class PayoutReportComponent implements OnInit {

  filterable = {
    source: 7,
    country: 'TH',
    month: null,
    year: null,
  };

  loading = false;
  emptyResult = true;
  tabDatas: any = [];
  active = 0;

  sourceList = { 'Pay365': 7 };
  countryList = { 'Thailand': 'TH' };

  yearList = [];
  monthList = [
    { "name": 'January', "value": 1 },
    { "name": 'February', "value": 2 },
    { "name": 'March', "value": 3 },
    { "name": 'April', "value": 4 },
    { "name": 'May', "value": 5 },
    { "name": 'June', "value": 6 },
    { "name": 'July', "value": 7 },
    { "name": 'August', "value": 8 },
    { "name": 'September', "value": 9 },
    { "name": 'October', "value": 10 },
    { "name": 'November', "value": 11 },
    { "name": 'December', "value": 12 },
  ];

  constructor(
    private payoutSvc: PayoutService,
    private notification: NotificationService) {

  }

  ngOnInit(): void {
    let dte = new Date();
    let currentYear = dte.getFullYear();
    this.yearList.push(currentYear);
    this.yearList.push(currentYear - 1);
    this.yearList.push(currentYear - 2);
    // goto previous 3 month
    if (dte.getMonth() >= 3) {
      this.filterable.year = currentYear;
      this.filterable.month = dte.getMonth() - 3 + 1;
    } else {
      this.filterable.year = currentYear - 1;
      this.filterable.month = 12 - dte.getMonth();
    }
  }

  search() {
    this.loadPage();
  }

  verifyExport(){
    this.loading = true;
    this.emptyResult = true;
    this.tabDatas = [];
    let month;
    if (this.filterable.month >= 10) {
      month = "" + this.filterable.year + this.filterable.month;
    } else {
      month = this.filterable.year + "0" + this.filterable.month;
    }
    // get page of items from api
    this.payoutSvc.verify(this.filterable.source, this.filterable.country, month).pipe(first()).subscribe(data => {
      if (data.status == 1) {
        if (data.data != null) {
          this.loading = false;
          this.emptyResult = false;
          this.tabDatas.push({
              title: "Summary",
              urls: {
                "付款核对报表": data.data,
              }
          });
        } else {
          this.loading = false;
          this.emptyResult = true;
          this.notification.showWarning("There is no payout report", "Empty Result");
        }
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showError(data.msg, "Error Msg");
      }
    });
  }

  private loadPage() {
    this.loading = true;
    this.emptyResult = true;
    this.tabDatas = [];
    let month;
    if (this.filterable.month >= 10) {
      month = "" + this.filterable.year + this.filterable.month;
    } else {
      month = this.filterable.year + "0" + this.filterable.month;
    }
    // get page of items from api
    this.payoutSvc.export(this.filterable.source, this.filterable.country, month).pipe(first()).subscribe(data => {
      if (data.status == 1) {
        if (data.data != null) {
          this.loading = false;
          this.emptyResult = false;
          this.tabDatas = data.data;
        } else {
          this.loading = false;
          this.emptyResult = true;
          this.notification.showWarning("There is no payout report", "Empty Result");
        }
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showError(data.msg, "Error Msg");
      }

    });
  }

}
